import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { LENDING_CONFIG_QUERY } from '@/shared/utils/lending';

export const OFFSET_BPS = 1;

export const useLendingConfig = () => {
  const { data, isLoading } = useGqlQuery(LENDING_CONFIG_QUERY, {
    context: { clientName: 'statechainCache' },
    refetchInterval: 6_000,
  });

  return {
    isLoading,
    targetLtvThresholdBps: (data?.config?.targetLtvThresholdBps ?? 0) - OFFSET_BPS, // Offsetting target threshold in order to avoid failing actions
    softLiquidationLtvThresholdBps: data?.config?.softLiquidationLtvThresholdBps ?? 0,
    lowLtvPenaltyThresholdBps: data?.config?.lowLtvPenaltyMaxLtvBps ?? 0,
    interestFeeNetworkShareBps: data?.config?.interestFeeNetworkShareBps ?? 0,
    lowLtvPenaltyBpsAtMaxLtv: data?.config?.lowLtvPenaltyBpsAtMaxLtv ?? 0,
    minLoanRequestAmountUsd: Number(data?.config?.minLoanRequestAmountUsd ?? 0),
    minLoanUpdateAmountUsd: Number(data?.config?.minLoanUpdateAmountUsd ?? 0),
    minSupplyAmountUsd: Number(data?.config?.minSupplyAmountUsd ?? 0),
  };
};
